import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/workSummary/table/csv${`?startDate=${string}&endDate=${string}&filterByText=${string}${`&subJobId=${number}` | ''}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/workSummary/table/csv`;

/**
 * @param startDate YYYY-MM-DD
 * @param endDate YYYY-MM-DD
 */
export const URL = (jobId: number, startDate: string, endDate: string, subJobId: Nullable<number>, filterByText: string): RouteDefinition =>
	`${baseRoute}/${jobId}/workSummary/table/csv?startDate=${startDate}&endDate=${endDate}&filterByText=${filterByText}&subJobId=${subJobId}`;
